import { useState, useEffect, useRef, useCallback } from "react";
import "./taxStyle.css";

import { AgGridReact } from "ag-grid-react";

import { CiUser } from "react-icons/ci";
import { FiPlus } from "react-icons/fi";
import { VscVerified } from "react-icons/vsc";
import { HiOutlineDocumentDownload } from 'react-icons/hi';

import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";
import WidgetsButton from "../../../components/Widgets/button";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { DialogContentText, Switch } from "@mui/material";

import { Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";

import makeAnimated from "react-select/animated";

import DatePicker from "react-datepicker";

import { useDispatch, useSelector } from "react-redux";
import {
  commonGetData,
  commonSaveData,
  initState,
  initCommonState
} from "../../../redux/slices/commonSlice";
import {
  fetchBranchData,
  initBranchState,
} from "../../../redux/slices/branchSlice";
import {
  fetchDepartmentData,
  initDepartState,
} from "../../../redux/slices/departmentSlice";
import {
  fetchDesignationList,
  initDesigState,
} from "../../../redux/slices/designationSlice";
import { initTaxState, taxSaveData, getTaxClaimFormData, initTaxClaim } from "../../../redux/slices/taxSlice";
import {
  getEmployeeTypeListPath,
  updateEmployementDetailsPath,
  updatePastEmployementDetailsPath,
  taxDocumentsPath,
  taxDocumentsApproveOrRejectPath,
  tdsClaimFormsPath,
  submitTDSClaimFormPath
} from "../../../services/config";
import CustomPagination from "../../../components/CustomPagination";
import Header from "./components/Header";
import Card from "./components/Card";
import Tabs from "./components/Tabs";

const animatedComponents = makeAnimated();

const TaxDeclaration = ({ user, userDetails, commonState }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (commonState.commonError) {
      toast.error(commonState.commonMessage);
      dispatch(initCommonState());
    }
    if (commonState.commonSuccess) {
      toast.success(commonState.commonMessage);
      dispatch(initCommonState());
    }
  }, [commonState]);

  return (
    <div className="body-container">
      <div className="page-body p-0 mb-4">

        <Widgets
          icon={<WidgetsIcon icon={<CiUser />} title="Employment Details" />}
          body={
            <>
              {userDetails.length && (
                <div className="setting-border height-auto p-4 mt-4 mb-4">
                  <EmploymentDetails
                    user={user}
                    userDetails={userDetails[0]}
                    commonState={commonState}
                  />
                </div>
              )}

              {userDetails.length && (
                <VerificationCheckList
                  user={user}
                  userDetails={userDetails[0]}
                  commonState={commonState}
                />
              )}
            </>
          }
        />
      </div>
    </div>
  );
};

const EmploymentDetails = ({ user, userDetails, commonState }) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.common);
  const branchState = useSelector((state) => state.branch);
  const departmentState = useSelector((state) => state.department);

  const [empTypeList, setEmpTypeList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);

  const getEmpList = useCallback(() => {
    dispatch(commonGetData(getEmployeeTypeListPath));
    dispatch(fetchBranchData(user.user_id));
    dispatch(fetchDepartmentData(user.user_id));
  }, []);

  useEffect(() => {
    getEmpList();
  }, []);

  useEffect(() => {
    if (state.commonGetSuccess) {
      const newArr = state.commonGetData?.map((v) => {
        return { label: v.type_name, value: v.employeeTypeId };
      });
      setEmpTypeList(newArr);
    }

    if (departmentState.depGetSuccess) {
      const newArr = departmentState.depGetData?.map((v) => {
        return { label: v.department_name, value: v.departmentId };
      });
      setDepartmentList(newArr);
      dispatch(initDepartState());
    }
  }, [state.commonGetSuccess, departmentState.depGetSuccess]);

  useEffect(() => {
    if (branchState.brnGetSuccess) {
      if (
        branchState.brnGetData &&
        branchState.brnGetData.length > 0 &&
        Array.isArray(branchState.brnGetData)
      ) {
        const newArr = branchState.brnGetData.map((v) => {
          return { label: v.branch_name, value: v.branchId };
        });
        const sortArr = newArr.sort((a, b) => (a.value < b.value ? -1 : 1));
        setBranchList(sortArr);
      }
      dispatch(initBranchState());
    }
  }, [branchState.brnGetSuccess]);

  const [updateEmployeeDetails, setUpdateEmployeeDetails] = useState({
    staffId: userDetails !== undefined ? userDetails.staffId : "",
    department: userDetails.department,
    employee_type: userDetails.emp_role,
    date_of_joining: userDetails.date_of_join,
    employee_id: userDetails.personalDetails.empId,
    job_title: userDetails.job_title,
    official_email: userDetails.official_email,
    esi_number: userDetails.esi_number,
    pf_number: userDetails.pf_number,

    employmentDetails: userDetails.employementNumber
      ? [
        {
          employementNumber: userDetails.employementNumber,
          companyName: userDetails.companyName,
          designation: userDetails.designation,
          fromDate: userDetails.fromDate,
          toDate: userDetails.toDate,
          companyAddress: userDetails.companyAddress,
        },
      ]
      : [],
  });

  const handelChange = (e) => {
    const {
      target: { name, value },
    } = e;
    setUpdateEmployeeDetails((pv) => ({ ...pv, [name]: value }));
  };

  const [saveData, setSaveData] = useState({
    modules: [],
  });

  const [modulesError, setModulesError] = useState(false);
  const handleBranchChange = (e) => {
    setSaveData({
      ...saveData,
      modules: e,
    });
    setModulesError(false);
  };

  const [validated, setValidated] = useState(false);

  const handelSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      if (
        saveData.modules.length > 0 ||
        (userDetails.branch != "" &&
          userDetails.branch != null &&
          userDetails.branch != undefined)
      ) {
      } else {
        setModulesError(true);
      }
    } else {
      const data = {
        path: updateEmployementDetailsPath,
        data: {
          userId: user.user_id,
          branch:
            saveData.modules.length > 0
              ? saveData.modules.map((v) => v.value).toString()
              : userDetails.branch,
          staffId: updateEmployeeDetails.staffId,
          department: updateEmployeeDetails.department,
          employee_type: updateEmployeeDetails.employee_type,
          date_of_joining: updateEmployeeDetails.date_of_joining,
          date_of_leaving: "13/10/2024",
          employ: updateEmployeeDetails.employ,
          job_title: updateEmployeeDetails.job_title,
          official_email: updateEmployeeDetails.official_email,
          esi_number: updateEmployeeDetails.esi_number,
          pf_number: updateEmployeeDetails.pf_number,
        },
      };

      dispatch(commonSaveData(data));
    }
  };


  const EmployeeRecords = [
    {
      name: "employee_id",
      label: "Employee Id",
      placeholder: "Enter Employee Id",
    },
    { name: "job_title", label: "Job Title", placeholder: "Enter Job Title" },
    {
      name: "branch",
      label: "Branches",
      placeholder: "Enter Branches",
      isMulti: true,
      chi: branchList,
    },
    {
      name: "department",
      label: "Departments",
      placeholder: "Enter Departments",
      chi: departmentList,
    },
    {
      name: "employee_type",
      label: "Employment Type",
      placeholder: "Enter Employee Type",
      chi: empTypeList,
    },
    { name: "date_of_joining", label: "Date of joining", type: "date" },
    {
      name: "official_email",
      label: "Office Email Id",
      placeholder: "Enter Office Email Id",
    },
  ];
  const [scroll, setScroll] = useState("paper");
  const [open, setOpen] = useState(false);

  const preSubmit = () => {
    document.getElementById("submit-form-1").click();
  };

  const savedBranch = userDetails.branch.split(",");

  const brnIndex =
    savedBranch !== undefined
      ? savedBranch.map((v) => {
        return branchList.findIndex((obj) => {
          return parseInt(obj.value) === parseInt(v);
        });
      })
      : [];

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "transparent", // Input ka background
      borderColor: "transparent",
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#1e1d2e", // Popup menu background
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? "gray" // Hover color
        : state.isSelected
          ? "#90caf9" // Selected color
          : "#1e1d2e", // Default
      color: "#fff",
      cursor: "pointer",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#333333", // Selected text color
    }),
  };

  useEffect(() => {
    if (commonState.commonError) {
      setOpen(false);
    }
    if (commonState.commonSuccess) {
      setOpen(false);
    }
  }, [commonState]);

  return (
    <div className="">
      <Row className="mt-2">
        {EmployeeRecords.map((item, i) => (
          <Col sm="6">
            <div className="flex-space-between">
              <span className="label-text">{item.label}</span>
              <span className="value-text">
                {item.isMulti && item.chi
                  ? brnIndex
                    ?.map((r) => branchList[r]?.label)
                    .filter(Boolean)
                    .join(", ")
                  : !item.isMulti && item.chi
                    ? item.chi.length > 0
                      ? item.chi.map((v, i) => {
                        return updateEmployeeDetails[item.name] ==
                          v.value
                          ? v.label
                          : null;
                      })
                      : null
                    : updateEmployeeDetails[item.name]}
              </span>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

const VerificationCheckList = ({ user, userDetails, commonState }) => {
  const dispatch = useDispatch();
  const taxStore = useSelector((state) => state.tax)


  const [validated, setValidated] = useState(false);
  const [open, setOpen] = useState(false);
  const [regimeType, setRegimeType] = useState("");
  const [confirm, setConfirm] = useState(false)
  const [claimFormData, setClaimFormData] = useState({
    "user_id": "",
    "staff_id": "",
    "regime_type": "",
    "tax_year": "",
    "hra_rent_paid": null,
    "landlord_name": null,
    "landlord_address": null,
    "landlord_pan": null,
    "leave_travel_amount": null,
    "interest_paid": null,
    "lender_name": null,
    "lender_address": null,
    "lender_pan": null,
    "sec_80c_1": null,
    "sec_80c_2": null,
    "sec_80c_3": null,    
    "sec_80c_4": null,
    "sec_80c_5": null,
    "sec_80c_6": null,
    "sec_80c_7": null,
    "sec_80ccc": null,
    "sec_80ccd": null,
    "sec_other_1": null,
    "sec_other_2": null,
    "sec_other_3": null,
    "sec_other_4": null,
    "sec_other_5": null,
    "status": "1",
  })


  const [scroll, setScroll] = useState("paper");

  const [isOpen, setIsOpen] = useState(false);
  const startOfCurrentYear = new Date(new Date().getFullYear(), 0, 1);
  const [yearRange, setYearRange] = useState([null, null]);
  const [startYear, endYear] = yearRange;

  const [financialYear, setFinancialYear] = useState(["", ""]);
  const [startFinancialYear, endFinancialYear] = financialYear;

  const datePickerRef = useRef(null);

  const handleFinancialYearChange = (update) => {
    setFinancialYear(update)

    if (update && update[0] && update[1]) {
      setClaimFormData((pre) => ({
        ...pre,
        "tax_year": `${update[0].getFullYear()} - ${update[1].getFullYear()}`,
      }))
      setIsOpen(false);
      datePickerRef.current.setOpen(false);
    }
  };

  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const downloadFile = (file) => {
    const link = document.createElement('a');
    link.href = file;
    link.setAttribute(
      'download',
      `FileName.pdf`,
    );
    link.setAttribute(
      'target',
      `_blank`,
    );
    // Append to html link element page
    document.body.appendChild(link);
    // Start download
    link.click();
    // Clean up and remove the link
    link.parentNode.removeChild(link);
  }

  const updateStatus = (data, val) => {
    const formData = {
      path: taxDocumentsApproveOrRejectPath,
      data: {
        "staffId": userDetails.staffId,
        "userId": user.user_id,
        "taxDocId": data.id,
        "isApprove": val // 1- Approve , 2-reject
      }
    }
    dispatch(commonSaveData(formData))
  }

  const columns = [
    {
      headerName: "SNo",
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 60,
      pinned: "left",
    },
    // {
    //   headerName: "Section",
    //   cellRenderer: (rowData) =>
    //     rowData.data.section ? rowData.data.section : "-",
    // },
    {
      headerName: "Category",
      cellRenderer: (rowData) =>
        rowData.data.docType ? rowData.data.docType : "-",
      flex: 1
    },
    {
      headerName: "Status",
      cellRenderer: (rowData) =>
        rowData.data.isApprove != undefined ? rowData.data.isApprove == "0" ? "Not Yet" : rowData.data.isApprove == "1" ? "Approved" : "Rejected" : "-",
      width: "150px"
    },
    {
      headerName: "Supporting Documents",
      cellRenderer: (rowData) =>
        rowData.data.fileUrl
          ? <div onClick={() => downloadFile(rowData.data.fileUrl)}><HiOutlineDocumentDownload style={{ fontSize: "26px", cursor: "pointer" }} /></div>
          : "-",
      width: "150px"
    },
    {
      headerName: "Actions",
      cellRenderer: (rowData) =>
        <div className="d-flex align-items-center justify-content-end gap-2">
          <button type="button" onClick={() => updateStatus(rowData.data, "1")} className="universal-btn" style={{ position: "relative", top: "5px", width: "100px", height: "30px", lineHeight: "10px" }}>Approve</button>
          <button type="button" onClick={() => updateStatus(rowData.data, "2")} className="secondary-btn" style={{ position: "relative", top: "5px", width: "100px", height: "30px", lineHeight: "10px" }}>Reject</button>
        </div>,
      pinned: "right",
    }
  ];

  const paginationPageSize = 10;
  const paginationPageSizeSelector = [10, 20, 50, 100];

  const [taxList, setTaxList] = useState([])

  const getTaxDetailList = () => {
    const formData = {
      staffId: userDetails?.staffId,
      userId: user.user_id
    }

    dispatch(taxSaveData({ path: taxDocumentsPath, data: formData }))
    dispatch(getTaxClaimFormData({ path: tdsClaimFormsPath, data: formData }))
  }

  useEffect(() => {
    getTaxDetailList()
  }, [])

  useEffect(() => {
    if (taxStore.taxSuccess || taxStore.taxError) {
      let data = taxStore.taxSuccess ? taxStore.taxData : []
      setTaxList(data)
      // let msgType = taxStore.taxSuccess ? "success" : "error"
      // toast[msgType](taxStore.taxMessage)
      dispatch(initTaxState())
    }
    if (taxStore.taxClaimSuccess) {
      setRegimeType(taxStore.taxClaimData.claimForm.regime_type)
      setClaimFormData((pre) => ({
        ...pre,
        "userId": taxStore.taxClaimData.claimForm.user_id,
        "staffId": taxStore.taxClaimData.claimForm.staff_id,
        "regime_type": taxStore.taxClaimData.claimForm.regime_type,
        "tax_year": taxStore.taxClaimData.claimForm.tax_year,
        "hra_rent_paid": taxStore.taxClaimData.claimForm.hra_rent_paid,
        "landlord_name": taxStore.taxClaimData.claimForm.landlord_name,
        "landlord_address": taxStore.taxClaimData.claimForm.landlord_address,
        "landlord_pan": taxStore.taxClaimData.claimForm.landlord_pan,
        "leave_travel_amount": taxStore.taxClaimData.claimForm.leave_travel_amount,
        "interest_paid": taxStore.taxClaimData.claimForm.interest_paid,
        "lender_name": taxStore.taxClaimData.claimForm.lender_name,
        "lender_address": taxStore.taxClaimData.claimForm.lender_address,
        "lender_pan": taxStore.taxClaimData.claimForm.lender_pan,
        "sec_80c_1": taxStore.taxClaimData.claimForm.sec_80c_1,
        "sec_80c_2": taxStore.taxClaimData.claimForm.sec_80c_2,
        "sec_80c_3": taxStore.taxClaimData.claimForm.sec_80c_3,
        "sec_80c_4": taxStore.taxClaimData.claimForm.sec_80c_4,
        "sec_80c_5": taxStore.taxClaimData.claimForm.sec_80c_5,
        "sec_80c_6": taxStore.taxClaimData.claimForm.sec_80c_6,
        "sec_80c_7": taxStore.taxClaimData.claimForm.sec_80c_7,
        "sec_80ccc": taxStore.taxClaimData.claimForm.sec_80ccc,
        "sec_80ccd": taxStore.taxClaimData.claimForm.sec_80ccd,
        "sec_other_1": taxStore.taxClaimData.claimForm.sec_other_1,
        "sec_other_2": taxStore.taxClaimData.claimForm.sec_other_2,
        "sec_other_3": taxStore.taxClaimData.claimForm.sec_other_3,
        "sec_other_4": taxStore.taxClaimData.claimForm.sec_other_4,
        "sec_other_5": taxStore.taxClaimData.claimForm.sec_other_5,
        "status": taxStore.taxClaimData.claimForm.status
      }))

      const split_tax_year = taxStore.taxClaimData.claimForm.tax_year.split("-")
      setFinancialYear([split_tax_year[0].trim(), split_tax_year[1].trim()])


      dispatch(initTaxClaim())
    }
    if (commonState.commonSuccess) {
      const formData = {
        staffId: userDetails?.staffId,
        userId: user.user_id
      }

      // dispatch(taxSaveData({path: taxDocumentsPath, data: formData }))
      dispatch(getTaxClaimFormData({ path: tdsClaimFormsPath, data: formData }))
      handleClose()
    }
  }, [taxStore, commonState])

  const handleClose = () => {
    setValidated(false);
    setOpen(false);
  };

  const selectRegimeType = (type) => {
    if (claimFormData.hra_rent_paid) {
      setConfirm(true)
    }
    else {
      setConfirm(false)
      setRegimeType(type)
    }

  }

  const handelInputChange = ({ target: { name, value } }) => {
    setClaimFormData((pre) => ({
      ...pre,
      [name]: value
    }))
  }

  const handleCloseConfirm = () => {
    setConfirm(false)
  }

  const removeRecords = () => {
    if (regimeType == "OLD") {
      setRegimeType("NEW")
    } else {
      setRegimeType("OLD")
    }
    setClaimFormData((pre) => ({
      ...pre,
      "hra_rent_paid": null,
      "landlord_name": null,
      "landlord_address": null,
      "landlord_pan": null,
      "leave_travel_amount": null,
      "interest_paid": null,
      "lender_name": null,
      "lender_address": null,
      "lender_pan": null,
      "sec_80c_1": null,
      "sec_80c_2": null,
      "sec_80c_3": null,
      "sec_80c_4": null,
      "sec_80c_5": null,
      "sec_80c_6": null,
      "sec_80c_7": null,
      "sec_80ccc": null,
      "sec_80ccd": null,
      "sec_other_1": null,
      "sec_other_2": null,
      "sec_other_3": null,
      "sec_other_4": null,
      "sec_other_5": null,
    }))
    setConfirm(false)
  }

  const handleSubmit = (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();
    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      let formData = {
        path: submitTDSClaimFormPath,
        data: claimFormData,
      };
      dispatch(commonSaveData(formData));
    }
  };

  const preSubmit = () => {
    let elem = document.getElementById("taxClaimFormId")
    if (elem) {
      elem.click()
    }
  }

  const preSubmitOne = () => {
    let elem = document.getElementById("taxClaimFormIdOne")
    if (elem) {
      elem.click()
    }
  }

  return (
    <div className="mb-3 mt-5">

      <div className="d-flex align-items-center justify-content-center gap-2">
        <div className="toggleContainer" style={{ width: "200px" }}>
          <Switch /> Old/New Regime
        </div>
        <div style={{ width: "200px" }}>
          <DatePicker
            selectsRange
            startDate={startYear} 
            endDate={endYear}
            onChange={(update) => setYearRange(update)}
            showYearPicker
            dateFormat="yyyy"
            minDate={startOfCurrentYear}
            placeholderText="Select Financial Year"
            className="universal-input"
          />
        </div>

        {/* <WidgetsButton
              type="button"
              icon={<FiPlus className="btn-icon" />}
              onClick={() => setOpen(true)}
            /> */}
      </div>


      <div
        className="ag-theme-quartz custom-grid mt-3 "
        style={{ height: "calc(100vh - 180px)", width: "100%" }}
      >
        <Header />
        <Card />
        <Tabs staffId={userDetails.staffId} />
      </div>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xl" // 'xs', 'sm', 'md', 'lg', 'xl'
        fullWidth
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        className="dark-bg-color"
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={handleClose}>
              X
            </span>
            <span className="title">Tax Declaration</span>
          </div>
          <button className="universal-btn border-radius-8px" onClick={regimeType == "OLD" ? preSubmit : preSubmitOne}>
            Submit Form
          </button>
        </DialogTitle>

        <DialogContent dividers={scroll === "paper"}>
          <DialogContentText
            id="scroll-dialog-description"
            // ref={descriptionElementRef}
            tabIndex={-1}
            style={{ position: "relative" }}
          >
            <h4 className="color-white mb-1">Select Regime Type</h4>

            <div className="option-button-container">
              <div className={regimeType == "OLD" ? "option-button active" : "option-button"} onClick={() => selectRegimeType("OLD")}>
                {/* <div className={regimeType == "OLD" ? "radio-btn active" : "radio-btn"}>
                  <div className="center-circle"></div>
                </div> */}
                <span>Old Regime</span>
              </div>
              <div className={regimeType == "NEW" ? "option-button active" : "option-button"} onClick={() => selectRegimeType("NEW")}>

                <span>New Regime</span>
              </div>
            </div>
            <hr className="color-gray" />
            {
              regimeType == "OLD" ?
                <div className="first-screen">
                  <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <h4 className="color-white mt-4">Select Financial Year</h4>
                    <Row>
                      <Col sm="3" className="mb-2">
                        <DatePicker
                          ref={datePickerRef}
                          selectsRange
                          startDate={startFinancialYear}
                          endDate={endFinancialYear}
                          onChange={(update) => handleFinancialYearChange(update)}
                          showYearPicker
                          dateFormat="yyyy"
                          minDate={startOfCurrentYear}
                          // open={isOpen}
                          onClick={() => setIsOpen(true)}
                          shouldCloseOnSelect={false}
                          placeholderText="Select Financial Year"
                          className="universal-input"
                        />
                      </Col>
                    </Row>
                    <hr className="color-gray" />
                    <h4 className="color-white mt-4">1. House Rent Allowence (HRA)</h4>
                    <hr className="color-gray" />
                    <Row>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">Rent Paid to the Landlord</Form.Label>
                          <Form.Control name="hra_rent_paid" value={claimFormData.hra_rent_paid} className="universal-input" onChange={handelInputChange} placeholder="Rent Paid to the Landlord" />
                        </Form.Group>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">Name of the Landlord</Form.Label>
                          <Form.Control name="landlord_name" value={claimFormData.landlord_name} className="universal-input" onChange={handelInputChange} placeholder="Name of the Landlord" />
                        </Form.Group>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">Address of the Landlord</Form.Label>
                          <Form.Control name="landlord_address" value={claimFormData.landlord_address} className="universal-input" onChange={handelInputChange} placeholder="Address of the Landlord" />
                        </Form.Group>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">PAN of the Landlord</Form.Label>
                          <Form.Control name="landlord_pan" value={claimFormData.landlord_pan} className="universal-input" onChange={handelInputChange} placeholder="PAN of the Landlord" />
                        </Form.Group>
                      </Col>
                    </Row>

                    <h4 className="color-white mt-2">2. Leave Travel Allowence (LTA)</h4>
                    <hr className="color-gray" />
                    <Row>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">Leave Travel Amount</Form.Label>
                          <Form.Control name="leave_travel_amount" value={claimFormData.leave_travel_amount} className="universal-input" onChange={handelInputChange} placeholder="Leave travel amount" />
                        </Form.Group>
                      </Col>
                    </Row>

                    <h4 className="color-white mt-2">3. Interest on Home Loan</h4>
                    <hr className="color-gray" />
                    <Row>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">Interest on Housing Loan</Form.Label>
                          <Form.Control name="interest_paid" value={claimFormData.interest_paid} className="universal-input" onChange={handelInputChange} placeholder="Interest on Housing Loan" />
                        </Form.Group>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">Lender Name</Form.Label>
                          <Form.Control name="lender_name" value={claimFormData.lender_name} className="universal-input" onChange={handelInputChange} placeholder="Lender Name" />
                        </Form.Group>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">Lender Address</Form.Label>
                          <Form.Control name="lender_address" value={claimFormData.lender_address} className="universal-input" onChange={handelInputChange} placeholder="Lender Address" />
                        </Form.Group>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">Lender PAN</Form.Label>
                          <Form.Control name="lender_pan" value={claimFormData.lender_pan} className="universal-input" onChange={handelInputChange} placeholder="Lender PAN" />
                        </Form.Group>
                      </Col>
                    </Row>

                    <h4 className="color-white mb-1 mt-2">4A. Section 80C Deductions</h4>
                    <h4 className="color-white mb-1 mt-1">Note: Follow this flow of example Below Deductions - 25000</h4>

                    <hr className="color-gray" />
                    <Row>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">80C Investment 1</Form.Label>
                          <Form.Control name="sec_80c_1" value={claimFormData.sec_80c_1} className="universal-input" onChange={handelInputChange} placeholder="80C Investment 1" />
                        </Form.Group>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">80C Investment 2</Form.Label>
                          <Form.Control name="sec_80c_2" value={claimFormData.sec_80c_2} className="universal-input" onChange={handelInputChange} placeholder="80C Investment 2" />
                        </Form.Group>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">80C Investment 3</Form.Label>
                          <Form.Control name="sec_80c_3" value={claimFormData.sec_80c_3} className="universal-input" onChange={handelInputChange} placeholder="80C Investment 3" />
                        </Form.Group>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">80C Investment 4</Form.Label>
                          <Form.Control name="sec_80c_4" value={claimFormData.sec_80c_4} className="universal-input" onChange={handelInputChange} placeholder="80C Investment 4" />
                        </Form.Group>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">80C Investment 5</Form.Label>
                          <Form.Control name="sec_80c_5" value={claimFormData.sec_80c_5} className="universal-input" onChange={handelInputChange} placeholder="80C Investment 5" />
                        </Form.Group>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">80C Investment 6</Form.Label>
                          <Form.Control name="sec_80c_6" value={claimFormData.sec_80c_6} className="universal-input" onChange={handelInputChange} placeholder="80C Investment 6" />
                        </Form.Group>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">80C Investment 7</Form.Label>
                          <Form.Control name="sec_80c_7" value={claimFormData.sec_80c_7} className="universal-input" onChange={handelInputChange} placeholder="80C Investment 7" />
                        </Form.Group>
                      </Col>
                    </Row>

                    <h4 className="color-white mb-1 mt-2">4B. Other Deductions</h4>
                    <h4 className="color-white mb-1 mt-1">Note: Follow this flow of example Below Deductions - 25000</h4>
                    <hr className="color-gray" />
                    <Row>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">Section 80CCC</Form.Label>
                          <Form.Control name="sec_80ccc" value={claimFormData.sec_80ccc} className="universal-input" onChange={handelInputChange} placeholder="Section 80CCC" />
                        </Form.Group>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">Section 80CCD</Form.Label>
                          <Form.Control name="sec_80ccd" value={claimFormData.sec_80ccd} className="universal-input" onChange={handelInputChange} placeholder="Section 80CCD" />
                        </Form.Group>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">Other Section 1</Form.Label>
                          <Form.Control name="sec_other_1" value={claimFormData.sec_other_1} className="universal-input" onChange={handelInputChange} placeholder="Other Section 1" />
                        </Form.Group>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">Other Section 2</Form.Label>
                          <Form.Control name="sec_other_2" value={claimFormData.sec_other_2} className="universal-input" onChange={handelInputChange} placeholder="Other Section 2" />
                        </Form.Group>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">Other Section 3</Form.Label>
                          <Form.Control name="sec_other_3" value={claimFormData.sec_other_3} className="universal-input" onChange={handelInputChange} placeholder="Other Section 3" />
                        </Form.Group>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">Other Section 4</Form.Label>
                          <Form.Control name="sec_other_4" value={claimFormData.sec_other_4} className="universal-input" onChange={handelInputChange} placeholder="Other Section 4" />
                        </Form.Group>
                      </Col>
                      <Col sm="3" className="mb-2">
                        <Form.Group>
                          <Form.Label className="color-gray">Other Section 5</Form.Label>
                          <Form.Control name="sec_other_5" value={claimFormData.sec_other_5} className="universal-input" onChange={handelInputChange} placeholder="Other Section 5" />
                        </Form.Group>
                      </Col>
                    </Row>

                    <button
                      type="submit"
                      className="universal-btn"
                      style={{
                        display: "none"
                      }}
                      id="taxClaimFormId"
                    >Submit Form</button>
                  </Form>
                </div>
                : null
            }
            {
              regimeType == "NEW" ?
                <div className="second-screen mt-4">
                  <h4 className="color-white">Tax Regime Declaration</h4>
                  <table className="tds-tbl">
                    <thead>
                      <tr>
                        <th>Income Tax Slab</th>
                        <th>Tax Rate</th>
                        <th>Surcharge Rate</th>
                        <th>Helth & Education</th>
                        <th>Effective Tax</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Up to 3 Lacs</td>
                        <td>NIL</td>
                        <td>NIL</td>
                        <td>NIL</td>
                        <td>NIL</td>
                      </tr>

                      <tr>
                        <td>3Lacs - 7Lacs</td>
                        <td>5%</td>
                        <td>NIL</td>
                        <td>4%</td>
                        <td>5.20%</td>
                      </tr>

                      <tr>
                        <td>7Lacs - 10Lacs</td>
                        <td>10%</td>
                        <td>NIL</td>
                        <td>4%</td>
                        <td>10.40%</td>
                      </tr>
                      <tr>
                        <td>10Lacs - 12Lacs</td>
                        <td>15%</td>
                        <td>NIL</td>
                        <td>4%</td>
                        <td>15.60%</td>
                      </tr>
                      <tr>
                        <td>12Lacs - 15Lacs</td>
                        <td>20%</td>
                        <td>NIL</td>
                        <td>4%</td>
                        <td>20.80%</td>
                      </tr>
                      <tr>
                        <td>15Lacs - 50Lacs</td>
                        <td>30%</td>
                        <td>NIL</td>
                        <td>4%</td>
                        <td>31.20%</td>
                      </tr>
                      <tr>
                        <td>50Lacs - 1Cr</td>
                        <td>30%</td>
                        <td>10%</td>
                        <td>4%</td>
                        <td>34.32%</td>
                      </tr>
                      <tr>
                        <td>1Cr - 2Cr</td>
                        <td>30%</td>
                        <td>15%</td>
                        <td>4%</td>
                        <td>35.00%</td>
                      </tr>
                      <tr>
                        <td>2Cr - 5Cr</td>
                        <td>30%</td>
                        <td>25%*</td>
                        <td>4%</td>
                        <td>39.00%</td>
                      </tr>
                      <tr>
                        <td>Above 5Cr</td>
                        <td>30%</td>
                        <td>25%*</td>
                        <td>4%</td>
                        <td>39.00%</td>
                      </tr>
                    </tbody>
                  </table>

                  <button
                    type="submit"
                    className="universal-btn"
                    style={{
                      display: "none"
                    }}
                    id="taxClaimFormIdOne"
                  >Submit Form</button>

                </div>
                : null
            }

          </DialogContentText>
        </DialogContent>
      </Dialog>

      {/* Alert for loss of data */}
      <Dialog
        fullWidth={true}
        open={confirm}
        onClose={handleCloseConfirm}
        style={{ width: "30%", margin: "0 auto" }}
      >
        <DialogContent
          style={{
            fontSize: "16px",
            fontWeight: "400",
          }}
        >
          You will loss your previous data if you change Regime Type.
        </DialogContent>
        <DialogActions style={{ borderTop: "1px solid lightgray" }}>
          <Button
            variant="contained"
            color="gray"
            onClick={handleCloseConfirm}
            className="border-radius-8px"
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              height: "30px",
              backgroundColor: "gray",
              color: "white",
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={removeRecords}
            className="universal-btn border-radius-8px"
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              height: "30px",
              width: "100px",
              color: "white",
            }}
          >
            ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default TaxDeclaration;
